import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { en } from "./en";
import { es } from "./es";

const dictionaries = { en, es };
const LanguageContext = createContext(null);

const detect = () => {
  const saved = localStorage.getItem("goox_lang");
  if (saved && dictionaries[saved]) return saved;
  return navigator.language?.toLowerCase().startsWith("es") ? "es" : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detect);

  useEffect(() => {
    localStorage.setItem("goox_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: dictionaries[lang] }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
